module.exports = __webpack_public_path__ + "static/media/pousada_2.e67d2bcf.jpg";